export class ClientDDL {
  text = "";
  value = 0;
}

export class ClientInfo {
  clientName = "";
  clientId = 0;
  isInterface = false;
  timezone = "";
  researchDuration?: number;
  showInsight = false;
}

export class ChangePasswordDto {
  currentPassword = "";
  newPassword = "";
  confirmPassword = "";
}

export class RegisterUserDto {
  username = "";
  password = "";
  confirm = "";
  firstName = "";
  lastName = "";
  role = "";
}

export class ChangePassword {
  username = "";
  currentPassword = "";
  newPassword = "";
}

export interface DropdownItem<T> {
  text: string;
  value: T;
}